import React from 'react'
import OverviewTable from './OverviewTable'

export default function CategoryOverviewTable() {
  return <OverviewTable module="CATEGORY" redirect="category" />
}
